module.exports = __webpack_public_path__ + "prod/1.42.2/img/faq4.8bf17f81.png";